import { activateUtilizationFixture, isUtilizationPractice, utilizationPracticeSession } from './practice/utilizationPractice';
import { utilizationSetupDish } from './utilizationValues';
import { findOnboardingTarget } from './findTarget';

function enter(stage: string, options: { fixture?: boolean; setup?: 'search' | 'select' | 'edit'; focusSearch?: boolean } = {}) {
  if (options.fixture) activateUtilizationFixture();
  const session = utilizationPracticeSession();
  let cancelled = false;
  let timer: ReturnType<typeof setTimeout>;
  let attempts = 0;
  let focusedSearch = false;
  const prepare = () => {
    if (cancelled || !isUtilizationPractice() || session !== utilizationPracticeSession()) return;
    window.dispatchEvent(new CustomEvent('onboarding:utilization-stage', { detail: { stage } }));
    if (stage === 'setup') window.dispatchEvent(new CustomEvent('onboarding:inventory-setup-reset'));
    if (options.setup) {
      window.dispatchEvent(new CustomEvent('onboarding:inventory-setup-tab', { detail: { tab: 'revenue' } }));
      window.dispatchEvent(new CustomEvent('onboarding:inventory-setup-search', { detail: { query: utilizationSetupDish() } }));
      if (options.setup !== 'search') window.dispatchEvent(new CustomEvent('onboarding:inventory-setup-select', { detail: { name: utilizationSetupDish() } }));
      if (options.setup === 'edit') window.dispatchEvent(new CustomEvent('onboarding:inventory-setup-continue'));
    }
    if (options.focusSearch && !focusedSearch) {
      const input = findOnboardingTarget('inventory-setup-search');
      if (input) { input.focus(); focusedSearch = true; }
    }
    // Late editors get a bounded retry; changing step cancels every queued action.
    if (++attempts < 20) timer = setTimeout(prepare, 100);
  };
  prepare();
  return () => { cancelled = true; clearTimeout(timer); };
}
export const showUtilizationPage = () => enter('welcome');
export const showUtilizationOverTab = () => enter('over');
export const showUtilizationTabs = () => enter('tabs');
export const showUtilizationProduct = () => enter('product');
export const showUtilizationOverview = () => enter('drawer');
export const showUtilizationBreakdown = showUtilizationOverview;
export const showUtilizationAddLink = () => enter('drawer', { fixture: true });
export const openUtilizationAddLink = () => enter('setup', { fixture: true });
export const showUtilizationSetupRevenue = () => enter('setup', { fixture: true, focusSearch: true });
export const searchUtilizationSetupDish = () => enter('setup', { fixture: true, setup: 'search' });
export const selectUtilizationSetupDish = () => enter('setup', { fixture: true, setup: 'select' });
export const showUtilizationProductAdded = () => enter('setup-edit', { fixture: true, setup: 'edit' });
export const fillUtilizationIngredientQty = () => enter('setup-edit', { fixture: true, setup: 'edit' });
export const showUtilizationLinked = () => enter('drawer', { fixture: true });
export const showUtilizationEditDish = showUtilizationLinked;
export const showUtilizationEditIngredient = () => enter('edit', { fixture: true });
export const fillUtilizationEditQty = () => enter('edit', { fixture: true });
export const closeUtilizationEdit = () => enter('product', { fixture: true });
export const showUtilizationFavoritePick = () => enter('favorite-pick', { fixture: true });
export const showUtilizationFavoriteTab = () => enter('favorite-tab', { fixture: true });
export const showUtilizationFavoritesTab = () => enter('favorites', { fixture: true });
export const pointUtilizationUnmappedTab = showUtilizationFavoritesTab;
export const showUtilizationUnmappedTab = () => enter('unmapped', { fixture: true });
export const showUtilizationSetupCta = showUtilizationUnmappedTab;
export const showUtilizationComplete = () => enter('complete');
